import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=8c5b8ea4&scoped=true&lang=pug"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=8c5b8ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5b8ea4",
  null
  
)

export default component.exports